import { render, staticRenderFns } from "./soscontact_modal.vue?vue&type=template&id=65aedb15&scoped=true&"
import script from "./soscontact_modal.vue?vue&type=script&lang=js&"
export * from "./soscontact_modal.vue?vue&type=script&lang=js&"
import style0 from "./soscontact_modal.vue?vue&type=style&index=0&id=65aedb15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aedb15",
  null
  
)

export default component.exports